import { Action } from '@ngrx/store';
import { loadPipesChunk } from '@app/main/main-screen/store/data/pipes/pipes.actions';
import { IPipesState, pipesKey } from '@app/main/main-screen/store/data/pipes/pipes.state';

/**
 * Redux DevTools serialize the whole state and every action they are sent; a pipe network of
 * hundreds of thousands of segments made that seconds per action. They get the counts instead.
 */
export function pipesDevtoolsStateSanitizer<S extends Record<string, unknown>>(state: S): S {
  const pipes = state[pipesKey] as IPipesState | undefined;
  if (!pipes?.ids.length) return state;

  return { ...state, [pipesKey]: { ...pipes, ids: `<${pipes.ids.length} ids>`, entities: '<segments>' } };
}

export function pipesDevtoolsActionSanitizer<A extends Action>(action: A): A {
  if (action.type !== loadPipesChunk.type) return action;

  const { segments } = action as unknown as ReturnType<typeof loadPipesChunk>;
  return { ...action, segments: `<${segments.length} segments>` };
}
